import { makeStyles } from "@inductiveautomation/ws-components";

export const getOrganizationStyles = makeStyles()(() => ({
  page: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: "100dvh",
  },
  // Inner scroll region so the body doesn't rubber-band on iOS (TS-2688).
  scrollContainer: {
    flex: 1,
    minHeight: 0,
    // App bar is outside the scroller, so the grid header sticks at the top.
    "--data-grid-sticky-offset": "0px",
  },
  dataGridContainer: {
    padding: "0 1.5rem 3rem 1.5rem",
    display: "flex",
    flexDirection: "column",
  },
  emptyRoot: {
    flexGrow: 1,
    display: "grid",
    placeItems: "center",
  },
  empty: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem",
  },
  requestError: {
    maxWidth: "40rem",
    marginBottom: "2rem",
  },
  emptyAvatar: {
    marginBottom: "1.5rem",
  },
  emptyHeading: {
    marginBottom: "0.5rem",
  },
}));
